module.exports = __webpack_public_path__ + "images/cartao_fidelidade.png?88f011c96d8dc35f7dc16cf26a858b8c";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/fidelidade/cartao_fidelidade.png
// module id = 980
// module chunks = 0